module.exports = __webpack_public_path__ + "img/speed-white.17ab75a3.svg";